import { useLogto } from '@logto/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppError from '@/components/AppError';
import useConsoleSignIn from '@/hooks/use-console-sign-in';
import { isEmbeddedConsole } from '@/utils/portal-session';
import { saveRedirect } from '@/utils/storage';

import AppLoading from '../AppLoading';

/** This component shows a loading indicator and tries to sign in again. */
function SessionExpired() {
  const { isLoading } = useLogto();
  const signIn = useConsoleSignIn();
  const { t } = useTranslation(undefined, { keyPrefix: 'admin_console' });

  useEffect(() => {
    if (!isLoading && !isEmbeddedConsole) {
      saveRedirect();
      void signIn();
    }
  }, [signIn, isLoading]);

  if (isEmbeddedConsole) {
    return (
      <AppError
        title={t('session_expired.title')}
        errorMessage={t('session_expired.subtitle')}
        onRetry={async () => {
          // A callback code is single-use. Start a new flow and return to the console home.
          saveRedirect(new URL('/console/', window.location.origin));
          await signIn();
        }}
      />
    );
  }

  return <AppLoading />;
}

export default SessionExpired;
